Vue.component('DashboardIndexComponent', require('./components/DashboardIndexComponent').default);
Vue.component('DashboardNoticesComponent', require('./components/DashboardNoticesComponent').default);
Vue.component('LandingIndexComponent', require('./components/LandingIndexComponent').default);

Vue.component('PatientDiscontinuationForm', require('./components/SecureSignForms/PatientDiscontinuationForm').default);
Vue.component('PharmacyRegistrationForm', require('./components/SecureSignForms/PharmacyRegistrationForm').default);
Vue.component(
    'PatientBulkTransferFormBrandToDenzapineApprovalForm',
    require('./components/SecureSignForms/PatientBulkTransferFormBrandToDenzapineApprovalForm').default
);
Vue.component('PatientRegistrationForm', require('./components/SecureSignForms/PatientRegistrationForm').default);
Vue.component(
    'PatientTransferFormFromBrandToDenzapine',
    require('./components/SecureSignForms/PatientTransferFormFromBrandToDenzapine.vue').default
);
Vue.component('PrescriberRegistrationForm', require('./components/SecureSignForms/PrescriberRegistrationForm').default);
Vue.component('ReChallengeRequestForm', require('./components/SecureSignForms/ReChallengeRequestForm').default);
Vue.component('OffLabelAgreementForm', require('./components/SecureSignForms/OffLabelAgreementForm').default);
Vue.component(
    'WebsiteUserRegistrationForm',
    require('./components/SecureSignForms/WebsiteUserRegistrationForm').default
);
Vue.component(
    'SecureSignFormRadioGroup',
    require('./components/SecureSignForms/partials/SecureSignFormRadioGroup').default
);
Vue.component(
    'SecureSignFormSignatureComponent',
    require('./components/SecureSignForms/partials/SecureSignFormSignatureComponent').default
);
Vue.component(
    'SecureSignFormRecaptcha',
    require('./components/SecureSignForms/partials/SecureSignFormRecaptcha').default
);
